import React, { useState } from 'react';
import styled from 'styled-components';
import White_Texture from '../../images/white-texture.png';
import { skillsets } from './skillset';
// import './skills.css'

export const Skills = () => {
  const [skillss, setSkillss] = useState(skillsets);
  const [skillsToShow, setSkillsToShow] = useState(5);

  const showMoreCats = () => {
    const newNumberOfCatsShown = skillsToShow + 5;
    // set it to the length of the array to show all the cats.
    setSkillsToShow(newNumberOfCatsShown);
  };

  return (
    <SkillsWrapper>
      {' '}
      <div className='kura_tm_section' id='skills'>
        <div className='kura_tm_skills'>
          <div className='container'>
            <div className='skills_inner'>
              <div className='left'>
                <div className='kura_tm_main_title light'>
                  <span>Skills</span>
                  <h3>Programming Skills</h3>
                </div>
                <div className='text wow fadeInUp' data-wow-duration='.7s'>
                  <p>
                    For more than 4 years I have been accomplishing enough with
                    modern Web Development, new generation web and app
                    programming language.
                  </p>
                </div>
                <div
                  className='dodo_progress wow fadeInUp'
                  data-wow-duration='.7s'
                  data-wow-delay='.2s'
                >
                  {skillss.slice(0, skillsToShow).map((skillset) => {
                    const { id, title, percentage, color } = skillset;
                    return (
                      <div key={id} className='progress_inner' data-value={percentage}>
                        <span>
                          <span className='label'>{title}</span>
                          <span className='number'>{percentage}</span>
                        </span>
                        <div className='background'>
                          <div
                            className='bar'
                            style={{
                              background: '#e89a38',
                              width: `${percentage}`,
                            }}
                          >
                            <div className='bar_in'></div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <center>
                    <button className='btn' onClick={() => showMoreCats()}>
                      load more
                    </button>
                  </center>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </SkillsWrapper>
  );
};

const SkillsWrapper = styled.section`
  /*---------------------------------------------------*/
  /*	06) KURA SKILLS
/*---------------------------------------------------*/

  .kura_tm_skills {
    width: 100%;
    height: auto;
    clear: both;
    float: left;
    position: relative;
    padding: 140px 15px 150px 15px;
  }
  .kura_tm_skills:before {
    position: absolute;
    content: '';
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background-image: url(${White_Texture});
    background-repeat: repeat;
    opacity: 0.6;
    z-index: 2;
  }
  .kura_tm_skills:after {
    position: absolute;
    content: '';
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background-color: #000;
    z-index: 1;
  }
  .kura_tm_main_title.light h3 {
    color: #fff;
  }
  .kura_tm_skills .skills_inner {
    width: 100%;
    float: left;
    height: auto;
    clear: both;
    position: relative;
    z-index: 3;
  }
  .kura_tm_skills .left {
    width: 60%;
    padding-right: 200px;
  }
  .kura_tm_skills .text {
    width: 100%;
    float: left;
    margin-top: 40px;
    margin-bottom: 44px;
  }
  .kura_tm_skills .text p {
    color: #bbb;
  }
  .dodo_progress {
    width: 100%;
    height: auto;
    clear: both;
    float: left;
  }
  .progress_inner {
    width: 100%;
    margin-bottom: 25px;
  }
  .progress_inner:last-child {
    margin-bottom: 0px;
  }
  .progress_inner > span {
    margin: 0px 0px 11px 0px;
    width: 100%;
    display: block;
    text-align: left;
    color: #fff;
    font-family: 'Poppins';
  }
  .progress_inner span.number {
    float: right;
  }
  .progress_inner .background {
    background: rgba(255, 255, 255, 0.09);
    width: 100%;
    min-width: 100%;
    position: relative;
    height: 8px;
  }
  .progress_inner .background .bar_in {
    height: 100%;
    ${'' /* background: #ff4522; */}
    width: 0px;
    overflow: hidden;
  }
  .progress_inner .background .bar {
    width: 0px;
    height: 100%;
  }
  .progress_inner .background .bar.open {
    -webkit-animation: wow 2s cubic-bezier(0.165, 0.84, 0.44, 1); /* Safari 4+ */
    -moz-animation: wow 2s cubic-bezier(0.165, 0.84, 0.44, 1); /* Fx 5+ */
    animation: wow 2s cubic-bezier(0.165, 0.84, 0.44, 1); /* IE 10+ */
    width: 100%;
  }

  .btn {
    background-color: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    border: 1px solid ${({ theme }) => theme.body};
    padding: 10px 20px;
    border-radius: 5px;
    margin-top: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    font-family : 'Poppins'
  }

  @-webkit-keyframes wow {
    0% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }
  @-moz-keyframes wow {
    0% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }
  @keyframes wow {
    0% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }

  .kura_tm_skills .right {
    width: 40%;
    position: absolute;
    right: 0px;
    top: 0px;
    bottom: -220px;
  }
  .kura_tm_skills .my_video {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
  }
  .kura_tm_skills .my_image {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .kura_tm_skills .right[data-background-style='video'] .my_image {
    display: none;
  }
  .kura_tm_skills .right[data-background-style='image'] .my_video {
    display: none;
  }

  @media (max-width: 1040px) {
    .mouse-cursor {
      display: none;
    }
    .kura_tm_topbar {
      display: none;
    }
    .kura_tm_mobile_menu {
      display: block;
    }
    .kura_tm_hero {
      padding: 150px 0px 120px 0px;
    }
    .kura_tm_hero .content {
      flex-direction: column-reverse;
      justify-content: space-around;
      align-items: baseline;
    }
    .kura_tm_hero .content .right {
      padding-left: 0px;
      margin-bottom: 60px;
      width: 100%;
    }
    .kura_tm_hero .content .left {
      padding-right: 0px;
      width: 100%;
    }
    .kura_tm_hero .content .right .image .shape {
      display: none;
    }
    .kura_tm_hero .content .right .image .main {
      transform: rotate(0deg);
    }
    body.opened .kura_tm_hero .content .right .image .main {
      transform: rotate(0deg);
    }
    .kura_tm_hero .job {
      font-size: 35px;
    }
    .kura_tm_hero .down {
      display: none;
    }
    .kura_tm_skills .right {
      display: none;
    }
    .kura_tm_skills .left {
      width: 100%;
      padding-right: 0px;
    }
    .kura_tm_pricing .pricing_inner {
      flex-direction: column;
    }
    .kura_tm_pricing .left {
      width: 100%;
      padding-right: 0px;
    }
    .kura_tm_pricing .right {
      width: 100%;
      padding-left: 0px;
    }
    .kura_tm_contact .contact_inner {
      flex-direction: column;
    }
    .kura_tm_contact .left {
      width: 100%;
      padding-right: 0px;
      margin-bottom: 30px;
    }
    .kura_tm_contact .right {
      width: 100%;
      padding-left: 0px;
    }
    .kura_tm_modalbox .box_inner {
      width: 500px;
    }
    .kura_tm_modalbox .close .svg {
      width: 40px;
      height: 40px;
    }
  }
`;
